import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, NuveiCreditCardDialogueHandler } from './types';
import NuveiCreditCardContext from './NuveiCreditCardContext';

const { ConfirmationDialogue } = vp;

type NuveiCreditCardDialogueProps = {
  handleDialogue: DialogueHandler<NuveiCreditCardDialogueHandler>;
  type: string;
};

type FC = FunctionComponent<NuveiCreditCardDialogueProps>;

const NuveiCreditCardDialogue: FC = ({ handleDialogue, type }: NuveiCreditCardDialogueProps) => {
  const { showNuveiCreditCardSuccessAlert, showNuveiCreditCardErrorAlert, nuveiCreditCardError } =
    useContext(NuveiCreditCardContext);
  const { t } = useTranslation('translations', {
    keyPrefix: type === 'credit' ? 'CreditCardDialouge' : 'DebitCardDialouge',
  });

  return useMemo(
    () => (
      <div>
        {/* Nuvei Credit Card Connection Success */}
        <ConfirmationDialogue
          isVisible={showNuveiCreditCardSuccessAlert}
          title={`${t('successfullMsg')}`}
          status="success"
          subTitle=""
          confirm={{
            label: `${t('doneButton')}`,
            action: () => handleDialogue({ type: 'connect', state: 'success' }),
          }}
        />
        {/* Nuvei Credit Card Connection Fail */}
        <ConfirmationDialogue
          isVisible={showNuveiCreditCardErrorAlert}
          title={
            <>
              {nuveiCreditCardError === 'DECLINED'
                ? `${t('declinedCreditCardError')}`
                : `${t('incorrectInfomrationError')}`}
            </>
          }
          variant="creditCard"
          status="fail"
          buttonColor="primary"
          subTitle={<>{nuveiCreditCardError === 'DECLINED' ? '' : nuveiCreditCardError}</>}
          confirm={{
            label: `${t('backButton')}`,
            action: () => handleDialogue({ type: 'connect', state: 'fail' }),
          }}
        />
      </div>
    ),
    [showNuveiCreditCardSuccessAlert, showNuveiCreditCardErrorAlert, nuveiCreditCardError],
  );
};

export default NuveiCreditCardDialogue;
